import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "400",
  height: "400",
  class: "icon",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F60",
      d: "M818.8 220.001c-2.8-.2-26.398-1.7-70.799-13.998-43.602-12.098-116.597-37.202-217-88.601l-19.098-10-19.098 10.102c-100.403 51.395-173.204 76.498-216.607 88.596-44.2 12.299-67.799 13.799-70.6 13.999h-40.8V538.5c0 65.398 18.698 121.2 57.2 170.501 32.2 41.4 74.2 73.703 127.201 109.599L512 916.701l161.7-97.399 1.198-.798c53.002-35.902 94.9-68.301 127.201-109.599 38.503-49.3 57.2-105.001 57.2-170.501V220zM678.703 647.2H345.201v-35.8h55.598V460.6h35.799v150.902H504.1l-.103-206.402h39.7v83.4h103.2v35.798h-103.2V611.6h135v35.6zm0-182.6C611.2 428.8 555.7 385.199 512 333.599c-43.7 47.6-99.2 91.3-166.702 131l-19.8-35.799c67.4-35.6 127.002-79.299 174.603-130.898h27.802c51.6 55.598 107.202 99.2 170.7 127.002z"
    }, null, -1)
  ])))
}
export default { render: render }